<template>
  <div class="field-preview">
    <div class="field-label">
      <span>{{ field.label }}</span>
      <v-chip x-small color="primary" class="ml-2" v-if="field.required">Required</v-chip>
    </div>

    <div class="field-description" v-if="field.description">
      <v-icon small color="grey">mdi-information-outline</v-icon>
      <span>{{ field.description }}</span>
    </div>

    <v-card outlined class="pa-3 mt-2 checkbox-options-container">
      <div v-if="hasOptions">
        <div
          v-for="option in sortedOptions"
          :key="option.id || option.value"
          class="checkbox-option"
        >
          <v-checkbox
            v-model="selectedOptions[option.value]"
            :label="option.label"
            :hint="option.value"
            hide-details
            class="option-checkbox"
          ></v-checkbox>
        </div>
      </div>
      <div v-else class="text-center py-2">
        <span class="caption">No options defined</span>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'CheckboxFieldPreview',
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedOptions: {}
    }
  },
  computed: {
    hasOptions() {
      return this.field.options && this.field.options.length > 0;
    },
    sortedOptions() {
      return [...(this.field.options || [])].sort(
        (a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)
      );
    },
    selectedValues() {
      return Object.entries(this.selectedOptions)
        .filter(([_, selected]) => selected)
        .map(([value]) => value);
    }
  },
  created() {
    // Initialize options
    if (this.hasOptions) {
      this.field.options.forEach(option => {
        this.$set(this.selectedOptions, option.value, false);
      });
    }
  }
}
</script>

<style scoped>
.field-preview {
  display: flex;
  flex-direction: column;
}

.field-label {
  font-weight: 500;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.field-description {
  margin-bottom: 8px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  gap: 4px;
}

.checkbox-options-container {
  background-color: #f9f9f9;
}

.checkbox-option {
  margin-bottom: 4px;
}

.option-checkbox:last-child {
  margin-bottom: 0;
}
</style>
